import {
  Component,
  OnInit,
  Optional,
  Inject,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CurrencyService } from 'src/app/util/currency.service';
import { MessageService } from 'src/app/common/services/message.service';
import { TranslateService } from '@ngx-translate/core';
import { FormaterService } from '../../services/formater.service';
import { LanguageService } from '../../services/language.service';
import { country } from '../../enums/language';
import { CROSS } from 'src/defaultImages.js';
@Component({
  selector: 'app-add-topup',
  templateUrl: './add-topup.component.html',
  styleUrls: [
    './add-topup.component.css',
    '../add-discount/add-discount.component.css',
  ],
})
export class AddTopupComponent implements OnInit {
  @ViewChild('customInput', { static: false }) customInput: ElementRef;
  images = {
    CROSS: CROSS,
  };
  currency: string = '';
  customDiscountValue: string = '';
  selectedAmount: string = '';
  customDiscount: any;
  selectedReason: string;
  selectedDiscount: string;
  customReason: string = '';
  modalTexts: any;

  topupReasonPresets = [
    { label: 'Extra Services' },
    { label: 'Additional Orders' },
    { label: 'Booking Fees' },
    { label: 'Pre-Ordered Items' },
  ];
  flatTopup = [
    { id: 1, name: `+${this.currency} 10`, value: '10', type: 'flat' },
    { id: 2, name: `+${this.currency} 15`, value: '15', type: 'flat' },
    { id: 3, name: `+${this.currency} 20`, value: '20', type: 'flat' },
    { id: 4, name: `+${this.currency} 25`, value: '25', type: 'flat' },
  ];

  constructor(
    private _dialogRef: MatDialogRef<any>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private _msgService: MessageService,
    private _currency: CurrencyService,
    private _translateService: TranslateService,
    private _formatService: FormaterService,
    private _languageService: LanguageService
  ) {
    this.currency = this._currency.getCurrency();
    this.customDiscount = (this.data || {}).customDiscount;

    try {
      if (this.customDiscount) {
        if (this.customDiscount.custom_flatTopup_list) {
          this.flatTopup = this.customDiscount.custom_flatTopup_list;
        }
      }
    } catch (error) {}
  }

  ngOnInit() {
    this._translateService.get('EDIT_AMOUNT').subscribe((data: any) => {
      this.modalTexts = { ...data };
      this.topupReasonPresets = [
        { label: this.modalTexts.EXTRA_SER },
        { label: this.modalTexts.ADDITIONAL_ORD },
        { label: this.modalTexts.BOOK_FEE },
        { label: this.modalTexts.PRE_ORD_ITM },
      ];
    });
    this._languageService.getCountry() === country.id.country &&
      this.setFixedTopUpDiscountPresets();
  }

  setFixedTopUpDiscountPresets() {
    this.flatTopup = [
      { id: 1, name: `${this.currency} 10.000`, value: '10000', type: 'fixed' },
      { id: 2, name: `${this.currency} 25.000`, value: '25000', type: 'fixed' },
      { id: 3, name: `${this.currency} 50.000`, value: '50000', type: 'fixed' },
      {
        id: 4,
        name: `${this.currency} 100.000`,
        value: '100000',
        type: 'fixed',
      },
    ];
  }

  inputChanges(e) {
    return e.charCode >= 44 && e.charCode <= 57 && e.charCode !== 47;
  }

  numBack(e) {
    this.customInput.nativeElement.value =
      this.customInput.nativeElement.value.substr(
        0,
        this.customInput.nativeElement.value.length - 1
      );
    this.customDiscountValue = this.customInput.nativeElement.value;
  }

  getNumber(number) {
    this.customInput.nativeElement.value += number;
    this.customDiscountValue = this.customInput.nativeElement.value;
  }

  getDecimal(e) {
    if (!this.customInput.nativeElement.value.includes(e)) {
      this.customInput.nativeElement.value += e;
      this.customDiscountValue = this.customInput.nativeElement.value;
    }
  }

  cancelClicked() {
    this._dialogRef.close({ status: 0, data: null, message: 'closed' });
  }

  submit() {
    if (this.selectedDiscount === 'custom_discount')
      this.selectedAmount = this.customDiscountValue;
    if (!this.selectedAmount) {
      this._msgService.showError(`${this.modalTexts.ENTER_DIS_VAL}`);
      return;
    } else {
      this._dialogRef.close({
        status: 1,
        data: {
          amount: +this._formatService.formatMy(this.selectedAmount),
          type: 'topup',
          reason:
            this.selectedReason !== 'other_reason'
              ? this.selectedReason
              : this.customReason,
        },
        message: this.modalTexts.COUPON_ADD,
      });
    }
  }

  reasonClicked(reason) {
    this.selectedReason = reason.label;
  }

  discountClicked(item) {
    this.selectedDiscount = item.name;
    this.selectedAmount = item.value;
    if (this.selectedDiscount === 'custom_discount') {
      setTimeout(() => {
        this.customInput.nativeElement.focus();
      }, 100);
    }
  }
}
